import { render, staticRenderFns } from "./SuggestionListeStallion.vue?vue&type=template&id=1e0886fb&"
import script from "./SuggestionListeStallion.vue?vue&type=script&lang=js&"
export * from "./SuggestionListeStallion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports